import React from "react";
import Logo from "../assets/Logo2.png";
import { SiLinkedin } from "react-icons/si";
import { BsYoutube } from "react-icons/bs";
import { FaTiktok } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { getAdjustingFontSizeByHeightWidth, getIsMobile } from "../globalConstants";
import { getScreenSize, getSectionHeight } from "../globalConstants";
import PocketPokerLogoHorizontalWithBackground from "../assets/PocketPokerLogoHorizontalWithBackground.png";
import { GetTheApp } from "./homeHelper";
import { ColourPalette } from "../globalConstants";
import { sendLog } from "../App";
import { trackSocialClick } from "../analytics/events";
import { CookieSettingsLink } from "./CookieBanner";
import { Link } from "react-router-dom";

const contactUsText = "Contact us via email info@parallelpoker.com"
const followUsText = "Follow us on instagram"
export const Footer = () => {
  const styles: { [key: string]: React.CSSProperties } = {
    footerWrapper: {
      display: "flex", width: "100%",
      flexDirection: "column",  // ← stack sections vertically on mobile
      height: "auto",           // ← let it grow naturally
    },
    footerSection: {
      flex: "2",
      display: "flex",
      flexDirection: "row",     // ← contact left, buttons right
      justifyContent: "space-between",
      alignItems: "center",
      padding: "5% 0",
    },
    footerIcons: {},
  };
  const heightReference = (parseFloat(getSectionHeight("footerHeight").replace("vh", "")) / 100) * getScreenSize().height
  return (
    <div
      className="footer"
      id="footer"
      style={{
        width: "100%",
        display: "flex",
        flex: 1,
        padding: "4%",          // ← more padding = taller footer
        position: "relative",
      }}
    >
      <div className="footer-wrapper" style={styles.footerWrapper}>
        <div className="footer-section" style={styles.footerSection}>

          {/* LEFT: contact info */}
          <div style={{ display: "flex", flexDirection: "column", gap: 12, flex: 1 }}>
            <span style={{ fontFamily: "Regular", fontSize: 14 }}>{contactUsText}</span>
            <Link style={{ fontFamily: "Regular" }} to="/support">Support</Link>
            <Link style={{ fontFamily: "Regular" }} to="/privacypolicy">Privacy Policy</Link>
            <Link style={{ fontFamily: "Regular" }} to="/deleteaccount">Request Account Deletion</Link>
            <CookieSettingsLink />
          </div>

          {/* RIGHT: download buttons + instagram */}
          <div style={{ display: "flex", flexDirection: "column", height: "auto", alignItems: "center", flex: 1, }}>
            <div style={{ height: heightReference, display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
              <GetTheApp placement="footer" inputStyle={{
                flexDirection: "column",
                height: "40%",
                display: "flex",
                alignItems: "center",
                gap: 12,
                // height: "auto",   // ← no more tiny heightReference * 0.1
              }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, width: 150 }}>
              <span
                onClick={() => { sendLog("Footer! Clicked on link to Instagram"); trackSocialClick("instagram", "footer"); window.open("https://www.instagram.com/playpocketpoker/") }}
                style={{ fontFamily: "Regular", fontSize: 14 }}
              >
                {followUsText}
              </span>
              <AiFillInstagram
                style={{ fontFamily: "Regular", fontSize: 70 }}
                onClick={() => { sendLog("Footer! Clicked on link to Instagram"); trackSocialClick("instagram", "footer"); window.open("https://www.instagram.com/playpocketpoker/") }}
              />
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};


export const FooterDesktop = () => {
  const styles: { [key: string]: React.CSSProperties } = {
    footerWrapper: {
      // margin: "6rem 0rem",
      // margin: "10vh",
      display: "flex",
      // marginTop: "10rem",
      flexDirection: getIsMobile() ? "column" : "row",
      height: getSectionHeight("footerHeight"),
      flex: 1,
    },
    footerLogoContainer: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      alignItems: "center",
    },
    footerSection: {
      flex: "2",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    footerIcons: {},
  };

  const heightReference = (parseFloat(getSectionHeight("footerHeight").replace("vh", "")) / 100) * getScreenSize().height

  return (
    <div
      className="footer"
      id="footer"
      style={{
        width: getScreenSize().width,
        display: "flex",
        flex: 1,
        alignItems: "center",
        position: "relative",
        justifyContent: "center",
        padding: "5%",

        // height: "100%",
      }}
    >
      <div className="footer-wrapper" style={styles.footerWrapper}>
        {/* <div
          className="footer-logo-container"
          style={styles.footerLogoContainer}
        >
          <img
            src={PocketPokerLogoHorizontalWithBackground}
            style={{
              objectFit: "contain",
              width: "100%",
              height: "100%"
            }}
            alt=""
          />
        </div> */}
        {/* <div className="footer-icons">
        <FaTiktok />
        <AiFillInstagram />
        <BsYoutube />
        <SiLinkedin />
      </div> */}
        <div className="footer-section" style={styles.footerSection}>
          <div style={{
            alignItems: "center",
            justifyContent: "space-evenly",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",        // ← needs explicit height to space evenly within
            minHeight: 120,        // ← fallback if parent height collapses
          }} className="footer-section-columns">
            <span style={{
              fontFamily: "Regular",
              fontSize: getAdjustingFontSizeByHeightWidth(
                getScreenSize().height * 0.05,
                getScreenSize().width * 0.5,
                contactUsText.length,
                28
              )
            }}>{contactUsText}</span>
            <Link style={{ fontFamily: "Regular" }} to="/support">Support</Link>
            <Link style={{ fontFamily: "Regular" }} to="/privacypolicy">Privacy Policy</Link>
            <Link style={{ fontFamily: "Regular" }} to="/deleteaccount">Request Account Deletion</Link>
            <CookieSettingsLink />
          </div>
          <div className="footer-section-columns" style={{ alignItems: "center", justifyContent: "center", display: "flex", flex: 1 }}>
            {/* <span className="footer-section-heading">
              Available anytime, anywhere!
            </span> */}
            <span style={{ width: "100%" }}>
              <GetTheApp placement="footer" inputStyle={{
                flexDirection: "row",
                height: heightReference * 0.9,
                display: "flex",
                width: "100%",
                justifyContent: "center",  // ← was "space-evenly"
                alignItems: "center",       // ← was "space-evenly" (invalid value)
                gap: "10%",                    // ← adds spacing between buttons
              }} />
            </span>
            <div className="footer-icons">
              {/* <FaTiktok /> */}
              <span onClick={() => { sendLog("Footer! Clicked on link to Instagram"); trackSocialClick("instagram", "footer"); window.open("https://www.instagram.com/playpocketpoker/") }} style={{
                fontFamily: "Regular", margin: 5, fontSize: getAdjustingFontSizeByHeightWidth(
                  getScreenSize().height * 0.02,
                  getScreenSize().width * 0.2,
                  followUsText.length,
                  28
                )
              }}>{followUsText}</span>
              <AiFillInstagram onClick={() => { sendLog("Footer! Clicked on link to Instagram"); trackSocialClick("instagram", "footer"); window.open("https://www.instagram.com/playpocketpoker/") }} />
              {/* <BsYoutube />
              <SiLinkedin /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



